/**
 * Textos do teto do MEI derivados de lib/calculos/constantes.ts — pra copy que
 * precisa continuar certa quando o ano vira (2026: R$ 81 mil; 2027: R$ 110 mil;
 * 2028+: R$ 140 mil — LC 238/2026).
 */
import { LIMITE_MEI_ANO, PROXIMO_LIMITE_MEI } from './constantes'

/** Teto em formato curto pra copy: 81000 → "R$ 81 mil". Padrão: teto do ano corrente. */
export function tetoMeiCurto(valor: number = LIMITE_MEI_ANO): string {
  return `R$ ${(valor / 1000).toLocaleString('pt-BR', { maximumFractionDigits: 1 })} mil`
}

/**
 * Nota do próximo teto já definido em lei, com espaço e parênteses:
 * " (R$ 110 mil a partir de 2027)". Vazia quando o teto não muda no ano seguinte.
 */
export function notaProximoTeto(): string {
  return PROXIMO_LIMITE_MEI.valor > LIMITE_MEI_ANO
    ? ` (${tetoMeiCurto(PROXIMO_LIMITE_MEI.valor)} a partir de ${PROXIMO_LIMITE_MEI.ano})`
    : ''
}
